import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';
import { CtaButton } from '../styled';

const Container = styled.div`
  text-align: center;
`;

const CtaContainer = styled.div`
  padding: 72px 25px
`;

const CtaHeadline = styled.div`
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.42px;
`;

const CtaDescription = styled.div`
  color: #7d7d7d;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
`;

const PrimaryButton = styled(CtaButton)`
  background: #1e5cb3;
  color: #ffffff;
  margin-top: 32px;

  &:hover {
    background: #3f81df;
  }

  &:active {
    background: #133a71;
  }
`;

const SecondaryButton = styled(CtaButton)`
  margin-top: 16px;
  box-shadow: 0px 0.5px 4.5px 0 rgba(0, 0, 0, 0.12)
`;

const ExchangeListArea = styled.div`
  background: #f7f7f7;
  padding: 72px 25px;

  img {
    height: 34px;
    margin-bottom: 54px;
  }
`;

const ExchangeListInner = styled.div`
  max-width: 990px;
  margin: 0 auto;
`;

const ListHeadline = styled.div`
  color: #7d7d7d;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 76px;
`;

function ExchangePartnersSection({ input }) {
  return (
    <Container>
      <div>
        <Grid columns={2} columnGap={0}>
          <Cell xs={2} sm={2}>
            <CtaContainer>
              <CtaHeadline>{input.primary.cta_headline.text}</CtaHeadline>
              <CtaDescription>{input.primary.cta_description.text}</CtaDescription>
              <div>
                <a href={input.primary.primary_cta_link.url} target="_blank" rel="noopener noreferrer">
                  <PrimaryButton>{input.primary.primary_cta_label.text}</PrimaryButton>
                </a>
              </div>
              <div>
                <a href={input.primary.secondary_cta_link.url} target="_blank" rel="noopener noreferrer">
                  <SecondaryButton>{input.primary.secondary_cta_label.text}</SecondaryButton>
                </a>
              </div>
            </CtaContainer>
          </Cell>
         
        </Grid>
      </div>
    </Container>
  );
}

export { ExchangePartnersSection };
